import { AmiraResources } from "@/models/AmiraResources.interface";

export const calculateTotalDuration = (
  newAssignments: AmiraResources[],
  currentAssignments: AmiraResources[],
  removingAssignments: AmiraResources[],
  getTimeAssigned: (resourceType: string, storiesCount: number) => number
): number => {
  let duration = 0;
  const removingIds = new Set(removingAssignments.map(a => a.resourceUniqueId));

  currentAssignments.forEach(assignment => {
    if (!removingIds.has(assignment.resourceUniqueId)) {
      duration += getTimeAssigned(assignment.resourceType, assignment.storyIds?.length ?? 1);
    }
  });

  newAssignments.forEach(assignment => {
    duration += getTimeAssigned(assignment.resourceType, assignment.storyIds?.length ?? 1);
  });

  return duration;
};